/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { getConfig } from './config'

export interface SignFile {
  genDiffFilename: boolean;
  filename: string;
  contentType: string;
  folder: string;
  environment: string | 'public';
}

export interface SignFileResponse {
  method: string;
  url: string;
  // fields: any[];
  headers: { [key: string]: string };
}

export interface UploadResponse {
  success: boolean;
}

export const getSignedUploadUrl = async (data: SignFile): Promise<SignFileResponse> => {
  const config = getConfig()

  const response = await config.axiosWithoutCredentials.post<SignFileResponse>(`${config.WORKERS_URL}/helpers/upload/sign`, data)

  return response.data
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const uploadToS3 = async (url: string, file: any, headers: { [key: string]: string }) : Promise<UploadResponse> => {
  return window.fetch(url, {
    method: 'PUT',
    headers,
    body: file
  }).then(function (response) {
    if (response.status >= 400 && response.status < 600) {
      throw new Error('Bad response from server')
    }
    return { success: true }
  }).catch(err => {
    // Sentry.captureException(err)
    // Sentry.captureMessage('MESSAGES OF ERROR')
    // Sentry.captureMessage(`file exists: ${!!file}`)
    // Sentry.captureMessage(JSON.stringify(err))
    // Sentry.captureMessage(JSON.stringify(headers))
    throw err
  })
}
